export default __webpack_public_path__ + "static/media/close-icon-gray.07c9aeab.svg";